import { useState } from 'react'
import { useDebounce } from 'hooks'

export const useDebounceSearch = (callback, { min = 1, delay = 800, query, skip = false }) => {
    const [keyword, setKeyword] = useState('')
    const { isTyping, debouncedValue } = useDebounce(keyword, delay)

    const res = callback(
        { keyword: debouncedValue.trim(), query },
        {
            skip: !debouncedValue || debouncedValue.trim().length < min || skip,
        }
    )

    return {
        isTyping: isTyping && !skip,
        setKeyword,
        keyword,
        ...res,
    }
}
